import { profileDto } from "../../app/modules/profile/dto/profileDto";
import { eventSubscriptionDto } from "../../app/modules/systemSettings/dto/eventSubscriptionDto";
import { serverDto } from "../../app/modules/systemSettings/dto/serverDto";
import { serverGroupDto } from "../../app/modules/systemSettings/dto/serverGroupDto";
import { userDto } from "../../app/modules/users/dto/userDto";

export const dtoRepo = {
  users: userDto,
  profile: profileDto,
  "system-settings/event-subscription": eventSubscriptionDto,
  "system-settings/servers": serverDto,
  "system-settings/server-groups": serverGroupDto,
}